module.exports = __webpack_public_path__ + "img/nursery6.14d1bcb0.jpg";